import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Mood from './Mood.js';
import "./i18n/config.ts";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Mood />
);
